import React from 'react';

import moment from 'moment';

// Helper function to check if a string is a valid URL
const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

export const statusBadge = {
  success: ['Success', 'Accepted'],
  error: ['Rejected', 'Fail'],
  info: ['No Action']
}



export const formFields = {
  search: {
    key: 'search',
    type: 'string',
    label: '',
    displayLayout: 'col-md-11',
    placeholder: "Search"
  },

}


export const options = {
  columns: [
    // { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number', expand: true,},
    { id: 2, name: 'executedDate', label: 'EXECUTED DATE', sortable: true, type: 'date', component: (row) => <div>{row && row.executedDate ? row.executedDate : '-'}</div> },
    { id: 3, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string', component: (row) => <div title={row.campaignInfo}>{row && row.campaignInfo && row.campaignInfo.length > 28 ? `${row.campaignInfo.slice(0, 28)} ...` : row.campaignInfo}</div> },
    { id: 4, name: 'adSetId', label: 'ADSET ID', sortable: false, type: 'string', component: (row) => row && row.adSetId ? row.adSetId : " - " },
    { id: 4, name: 'roId', label: 'RO ID', sortable: false, type: 'string', component: (row) => row && row.roId ? row.roId : " - " },
    { id: 5, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string', component: (row) => <div>{row && row.platformName ? row.platformName : '-'}</div> },
    { id: 6, name: 'recoType', label: 'RECOMMENDATION TYPE', sortable: true, type: 'string', component: (row) => <div title={row.recoType}>{row && row.recoType && row.recoType.length > 28 ? `${row.recoType.slice(0, 28)} ...` : row.recoType}</div> },
    { id: 7, name: 'currentValue', label: 'CURRENT VALUE', sortable: true, type: 'string', component: (row) => row && row.currentValue && isValidUrl(row.currentValue) ? <a href={row.currentValue} target="_blank" rel="noopener noreferrer" style={{ display: 'block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.currentValue}>{row.currentValue}</a> : (row.currentValue || '-') },
    { id: 8, name: 'newValue', label: 'NEW VALUE', sortable: true, type: 'string', component: (row) => row && row.newValue && isValidUrl(row.newValue) ? <a href={row.newValue} target="_blank" rel="noopener noreferrer" style={{ display: 'block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.newValue}>{row.newValue}</a> : (row.newValue || '-') },
    {
      id: 9,
      name: 'status',
      label: 'STATUS',
      sortable: true,
      type: 'string',
      component: (row) => {
        const statusMap = {
          "0": <div className='badge badge-secondary text-dark'>No Action</div>,
          "1": <div className='badge bg-label-success'>Accepted</div>,
          "2": <div className='badge bg-label-danger'>Rejected</div>,
          "3": <div className='badge bg-label-success'>Execution Success</div>,
          "4": <div className='badge bg-label-danger'>Execution Failed</div>,
          "5": <div className='badge bg-label-info'>ReExecution</div>
        };

        return (
          <div>
            {statusMap[row.status] || <div className='badge badge-secondary text-dark'>No Action</div>}
          </div>
        );
      }
    }

  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'view',
    // text: 'Current Recommendation Details',
    icon: 'ti ti-eye color-beki',
    iconType: 'new',
    tooltip: 'view'
  },

  ],
  // recActive: true,
  // status: {
  //   key: 'rec_active',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: false,
  searchable: false,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const optionsHistory = {


  columns: [
    // { id: 1, name: 's.no', label: 'S.No.', sortable: true, type: 'number', expand: true,},
    // { id: 2, name: 'executedDate', label: 'EXECUTED DATE', sortable: true, type: 'date', component: (row) => <div>{row && row.executedDate ? row.executedDate : '-'}</div> },
    { id: 2, name: 'createdOn', label: 'CREATED DATE', sortable: true, type: 'date', component: (row) => <div>{row && row.createdOn ? row.createdOn : '-'}</div> },
    { id: 3, name: 'campaignInfo', label: 'CAMPAIGN INFO', sortable: true, type: 'string', component: (row) => <div title={row.campaignInfo}>{row && row.campaignInfo && row.campaignInfo.length > 28 ? `${row.campaignInfo.slice(0, 28)} ...` : row.campaignInfo}</div> },
    { id: 4, name: 'adSetId', label: 'ADSET ID', sortable: false, type: 'string', component: (row) => row && row.adSetId ? row.adSetId : " - " },
    { id: 4, name: 'roId', label: 'RO ID', sortable: false, type: 'string', component: (row) => row && row.roId ? row.roId : " - " },
    { id: 5, name: 'platformName', label: 'PLATFORM NAME', sortable: true, type: 'string', component: (row) => <div>{row && row.platformName ? row.platformName : '-'}</div> },
    { id: 6, name: 'recoType', label: 'RECOMMENDATION TYPE', sortable: true, type: 'string', component: (row) => <div title={row.recoType}>{row && row.recoType && row.recoType.length > 28 ? `${row.recoType.slice(0, 28)} ...` : row.recoType}</div> },
    { id: 7, name: 'currentValue', label: 'CURRENT VALUE', sortable: true, type: 'string', component: (row) => row && row.currentValue && isValidUrl(row.currentValue) ? <a href={row.currentValue} target="_blank" rel="noopener noreferrer" style={{ display: 'block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.currentValue}>{row.currentValue}</a> : (row.currentValue || '-') },
    { id: 8, name: 'newValue', label: 'NEW VALUE', sortable: true, type: 'string', component: (row) => row && row.newValue && isValidUrl(row.newValue) ? <a href={row.newValue} target="_blank" rel="noopener noreferrer" style={{ display: 'block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.newValue}>{row.newValue}</a> : (row.newValue || '-') },
    {
      id: 9,
      name: 'status',
      label: 'STATUS',
      sortable: true,
      type: 'string',
      component: (row) => {
        const statusMap = {
          "0": <div className='badge badge-secondary text-dark'>No Action</div>,
          "1": <div className='badge bg-label-success'>Accepted</div>,
          "2": <div className='badge bg-label-danger'>Rejected</div>,
          "3": <div className='badge bg-label-success'>Execution Success</div>,
          "4": <div className='badge bg-label-danger'>Execution Failed</div>,
          "5": <div className='badge bg-label-info'>ReExecution</div>
        };

        return (
          <div>
            {statusMap[row.status] || <div className='badge badge-secondary text-dark'>No Action</div>}
          </div>
        );
      }
    }
  ],
  actions: [
    {
      type: 'view',
      icon: 'ti ti-eye color-beki',
      iconType: 'new',
      tooltip: 'view'
    },
    //   {
    //   type: 'edit',
    //   text: '',
    //   icon: 'mdi mdi-pencil',
    //   tooltip: 'Edit'
    // }, {
    //   type: 'delete',
    //   text: '',
    //   icon: 'mdi mdi-delete',
    //   tooltip: 'Delete'
    // },
    // {
    //   type: 'view',
    //   text: '',
    //   icon: 'mdi mdi-link-off',
    //   tooltip: 'View'
    // },
    // {
    //   type: 'generateCode',
    //   text: 'Generate Code',
    //   icon: 'mdi mdi-code-tags',
    //   tooltip: 'Generate Code'
    // }
  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  // showSearch: true,
  // searchable: true,
  searchColumns: [
    { key: 'executedDate' },
    { key: 'campaignName' },
    { key: 'platform' },
    { key: 'recoType' },
    { key: 'currValue' },
    { key: 'newValue' },

  ],
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'desc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  },
  // CSVDownload: {
  //   type: 'bidderReport',
  //   showCSVButton: true,
  //   buttonName: 'Download',
  //   saveFileName: 'bidderReport'
  // }

}